import { useEnergyDashboardData } from "@features/ax/dashboard/hooks";
import { logEvent } from "@shared/analytics/analytics";
import { useEffect } from "react";
import { EnergyKPISection } from "./energyKpiSection";
import { HighestConsumingAssets } from "./highestConsumptionAssets";
import { MonthlyEnergyTrends } from "./monthlyTrends";
import { OperationalEfficiencyKPIs } from "./operationalEfficiency";

const EnergyUsage = () => {
  const { data: energyData } = useEnergyDashboardData();

  useEffect(() => {
    logEvent("Energy Dashboard Viewed", {});
  }, []);

  return (
    <div className="min-h-screen bg-background p-6">
      <div className="mx-auto max-w-[1600px]">
        <div className="space-y-8">
          <EnergyKPISection data={energyData} />

          <HighestConsumingAssets data={energyData} />

          <OperationalEfficiencyKPIs data={energyData} />

          <MonthlyEnergyTrends data={energyData} />
        </div>
      </div>
    </div>
  );
};

export default EnergyUsage;
